import { Icon } from "../../atoms/icons";
import { Box } from "../../primitives";
import { iconSize } from "../../tokens";

/**
 * Web chevron — rotation is driven by Radix's `data-state` attribute via the
 * `group-data-[state=open]:rotate-180` selector on the wrapper.
 */
export const AccordionChevron = ({
  className,
  disabled,
}: {
  className?: string;
  disabled?: boolean;
}) => (
  <Box className="web:transition-transform web:duration-200 web:group-data-[state=open]:rotate-180">
    <Icon
      name="CaretDown"
      size={iconSize.sm}
      color={disabled ? "neutral-foreground-attenuated" : "neutral-foreground-intermediate"}
      className={className}
    />
  </Box>
);
